import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/commissions/payment-history/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({ to: '/' })
    }
    // Internal-only, matching the authGuard on every /api/payouts route.
    if (auth.user?.role !== Role['Internal']) {
      throw redirect({ to: '/dashboard' })
    }
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
